import { BookingServiceClient, UserServiceClient, WaitingListServiceClient } from 'fitbeat.api-clients';
import { getApiConfig } from '../config';
import { GoogleAnalytics } from '../services/google-analytics';
import { AuthTokenBuilder } from './authTokenBuilder';

export const createBookingServiceClient = (): BookingServiceClient => new BookingServiceClient(
  getApiConfig(),
  fetch,
  new AuthTokenBuilder(),
  new GoogleAnalytics(),
);

export const createUserServiceClient = (): UserServiceClient => new UserServiceClient(
  getApiConfig(),
  fetch,
  null,
  new AuthTokenBuilder(),
  new GoogleAnalytics(),
);

export const createUnauthenticatedUserServiceClient = (): UserServiceClient => new UserServiceClient(
  getApiConfig(),
  fetch,
  null,
  undefined,
);

export const createWaitlistServiceClient = (): WaitingListServiceClient => new WaitingListServiceClient(
  getApiConfig(),
  fetch,
  new AuthTokenBuilder(),
  new GoogleAnalytics(),
);
